<template>
    <div>
        <chooseCityAndGrade @getDiagnosis="getDiagnosis"/>
        <pop/>
        <toastBlack/>
        <img v-if="!Object.keys(this.course).length" class="course-img" src="http://static1.izhikang.com/webresource/usertech-public/img/diagnosisCourse.png"/>
        <section v-if="!!Object.keys(this.course).length">
            <div class="course-detail-title">{{course.name}}</div>
            <div class="course-detail-group">
                <span class="course-detail-time-title">上课时间</span>
                <span class="course-detail-time">{{course.time}}</span>
            </div>
            <div class="course-detail-price">￥<span>{{course.price}}</span></div>
        </section>
        <div v-if="!!Object.keys(this.course).length" class="container-img">
            <div  id="h5MainPage"></div>
        </div>
        <div v-if="!!Object.keys(this.course).length" class="btn-bg">
            <div v-if="!!Object.keys(this.course).length"
                 class="btn"
                 :class="{
                 'disabled': subscribeButton.canClick !== 1,
                 'confirm-active': subscribeButton.canClick == 1}"
                 @click="handleSignUp">{{subscribeButton.text}}
            </div>
        </div>
    </div>
</template>

<script>
    import chooseCityAndGrade from './chooseCityAndGrade'
    import {mapActions} from 'vuex'
    import pop from './pop'
    import api from '../../../common/libs/api.js';
    import toastBlack from './toastBlack'
    import utils from '@/common/libs/utils.js';
    import localforage from "localforage";
    export default {
        data() {
            return {
                btnContent: '立即报名',
                isActive: true,   // 按钮是否点击状态
                isDisabled: false,  // 按钮是否禁用,
                isClick: true,   // 防止按钮重复点击或点击过快
                course: {},
                subscribeButton: {},
                channel: '',
                reqType: ''
            }
        },
        components: {
            chooseCityAndGrade,
            pop,
            toastBlack
        },
        mounted() {
            this.channel = utils.getParameter('channel') || ''
            // 埋点
            let obj = {
                page_name: 'home_page',
                channel: this.channel,
                stu_id: '',
                is_login: 0
            }
            localforage.getItem('izk-user').then(function(userData) {
                if (userData) {
                    obj.stu_id = userData.student_id || ''
                    obj.is_login = 1
                    return;
                }
            }).finally(() => {
                utils.bury('enter_page', obj);
            });

        },
        methods: {
            ...mapActions(['updatePop', 'toastBlack']),
            renderLubanDetail() {
                this.$store.commit('isShowLoading', true)
                let lubanEngine = 'https://static1.izhikang.com/webresource/luban-engine-beta/engine-assets/1.0.0/engine.umd.min.js';
                if (process.env.NODE_ENV == 'production') {
                  utils.loadStyle("https://static1.izhikang.com/webresource/luban-engine-prod/engine-assets/1.0.0/engine.css")
                    lubanEngine = 'https://static1.izhikang.com/webresource/luban-engine-prod/engine-assets/1.0.0/engine.umd.min.js'
                } else {
                  utils.loadStyle("https://static1.izhikang.com/webresource/luban-engine-beta/engine-assets/1.0.0/engine.css")
                }
                new Function(this.course.content)()
                utils.loadScript(`${lubanEngine}?tiemstamp=${utils.formatDate(new Date(), 'yyyyMMdd')}`, () => {
                  engine && engine.default.vueInit("#h5MainPage")
                  this.$store.commit('isShowLoading', false)
                })
            },
            /**
             * 处理点击立即报名按钮后的逻辑
             */
            async handleSignUp() {
                if (this.isClick) {
                    // this.$router.push({name: 'chooseTime', query: { productId: this.course.bizId, channel: this.channel}})
                    // 提交前的校验  取消了
                    // 2020/11/3 晚启动
                    let obj = {
                        channel: this.channel,
                        stu_id: '',
                        is_login: 0
                    }
                    await localforage.getItem('izk-user').then(function(userData) {
                        if (userData) {
                            obj.stu_id = userData.student_id || ''
                            obj.is_login = 1
                            return;
                        }
                    })
                    await api.apiMethod.productTimeCheck.get({
                        productId: this.course.bizId,
                        type: this.reqType,
                        cityCode: utils.cookie.get('cityCode')||'010'
                    }).then(res => {
                        if (res.data.errcode === 0) {
                            utils.bury('click_zhenduanke_h5_course_001', obj);
                            this.$router.push({name: 'chooseTime', query: { productId: this.course.bizId, channel: this.channel}})
                        } else {
                            // 需要toast提醒“课程已约满“
                            // 如果时间超出上课时间
                            // this.toastBlack({
                            //     show: true,
                            //     title: res.data.msg
                            // })
                            const msg = res.data.msg
                            const code = res.data.errcode
                            if (code == 11000 ) {
                                // this.$store.commit('isScroll', true);
                                this.updatePop({
                                    show: true,
                                    title: '暂不能购买',
                                    content: msg
                                })

                            } else {
                                this.toastBlack({
                                    show: true,
                                    title: msg
                                })
                            }
                        }
                    })
                    this.isClick = false
                    setTimeout( () => {
                        this.isClick = true
                        // this.$store.commit('isShowLoading', false)
                    }, 1500)
                }
            },
            /**
             * 从父组件获取页面ID以及产品类型
             */
            getDiagnosis(data, cityCode, gradeId) {
                // 埋点
                let obj = {
                    page_name: 'home_page',
                    channel: this.channel,
                    stu_id: '',
                    is_login: 0,
                    course_city: cityCode,
                    course_grade: gradeId
                }
                localforage.getItem('izk-user').then(function(userData) {
                    if (userData) {
                        obj.stu_id = userData.student_id || ''
                        obj.is_login = 1
                        return;
                    }
                }).finally(() => {
                    utils.bury('click_confirn', obj);
                });
                // 为了获取 type，因为不知道前后的type是否一样
                const { type } = data
                this.reqType = type
                api.apiMethod.detail.get(data).then((res) => {
                    const data = res.data
                    if (data.errcode === 0) {
                        this.course = data.data
                        this.subscribeButton = data.data.bottomButtonInfo.diagnosisButton
                        this.renderLubanDetail()
                    }
                })
            }
        }

    }
</script>

<style scoped>
    .course-img {
        width: 100%;
        height: 100%;
        /*height: 4.5rem;*/
    }
    section {
        padding: 0.4rem;
        font-family: PingFangSC-Medium, PingFang SC;
        color: #333333;
        border-bottom: 0.2rem solid #F8F8F8;
    }
    .course-detail-title {
        font-size: 0.36rem;
        font-weight: 500;
    }
    .course-detail-group {
        font-size: 0.28rem;
        margin: 0.2rem 0 0.4rem 0;
    }
    .course-detail-group .course-detail-time-title {
        color: #999999;
        margin-right: 0.2rem;
    }

    .course-detail-group .course-detail-time {
    }

    .course-detail-price {
        font-size: 0.24rem;
        color: #CD0014;
    }
    .course-detail-price span {
        font-size: 0.4rem ;
    }
    .container-img {
        padding: 0.4rem 0 1.5rem;
        overflow: hidden;
    }

    .btn-bg {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 1.2rem;
        background: #FFFFFF;
        border-top: 0.01rem solid #E2E2E2;
        border-bottom: 0.01rem solid #E2E2E2;
        z-index: 9999;
    }
    .btn {
        margin:  0.16rem auto ;
        width: 6.3rem;
        height: 0.88rem;
        background: #E2E2E2;
        border-radius: 0.08rem;

        text-align: center;
        font-size: 0.3rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 0.88rem;
    }
    .confirm-active {
        background: #CD0014;
        color: #FFFFFF;
    }
    .disabled {
        pointer-events: none;
    }


</style>




// WEBPACK FOOTER //
// src/components/diagnosisCourse/detail/diaDetail.vue